<div
  class="dialog {{'ignoreClicks-' + data.fieldParameters.field.name}}"
  [ngClass]="data.secondDialogOpen ?   'ignoreClicksModal-' + data.fieldParameters.field.name : ''"
>
  <div
    mat-dialog-title
    class="modal-header"
  >
    <h1 class="modal-title">
      @if (modelTitle) {
        <span>
          {{modelTitle | translate}}
        </span>
      }
      @else {
        <span>
          {{ 'TRANS__EDIT_OBJECT_DIALOG__CREATE_ENTITY' | translate }}
        </span>
      }
    </h1>

    <button
      type="button"
      mat-icon-button
      class="close"
      [tabindex]="-1"
      aria-label="close dialog"
      mat-dialog-close=""
    >
      <mat-icon>
        close
      </mat-icon>
    </button>
  </div>

  @if (sectionsContainer.formGroup) {
    <form
      (ngSubmit)="onSubmit()"
      [formGroup]="sectionsContainer.formGroup"
      class="inherit-border-color"
    >
      <div
        mat-dialog-content
        class="modal-body modal-body-edit-fields"
      >
        <div class="modal-main-content">
          @if (referenceUsageInfo) {
            <app-reference-usage
              [referenceUsageInfo]="referenceUsageInfo"
              [showReferencesAsLink]="false"
            ></app-reference-usage>
          }

          @if (primeFields) {
            <app-edit-fields
              [sectionsContainer]="sectionsContainer"
              [object]="sectionsContainer.rootObject"
              [fields]="primeFields"
            ></app-edit-fields>
          }
          @else {
            <app-section-view-edit
              [sectionsContainer]="sectionsContainer"
            ></app-section-view-edit>
          }
        </div>
      </div>

      <div
        mat-dialog-actions
        class="modal-footer"
      >
        <button
          mat-flat-button
          type="submit"
          class=""
          color="accent"
          tabindex="0"
          [disabled]="!isValid"
        >
          <span class="bold">
            {{ 'TRANS__EDIT_OBJECT_DIALOG__SUBMIT' | translate }}
          </span>
        </button>

        <button
          type="button"
          class=""
          mat-button
          color="accent"
          tabindex="0"
          (click)="dialogRef.close(false)"
          (keyup)="($event.key === 'Enter') && dialogRef.close(false)"
        >
          <span class="bold">
            {{ 'TRANS__EDIT_OBJECT_DIALOG__CANCEL' | translate }}
          </span>
        </button>

        @if (storeStatus.failed) {
          <div>
            {{storeStatus.message | translate}} {{storeStatus.serverMsg}}
          </div>
        }
      </div>
    </form>
  }

  @if (!sectionsContainer.formGroup && storeStatus.failed) {
    <div class="modal-footer">
      <div>
        <h3>
          {{storeStatus.message | translate}}
        </h3>
      </div>

      <button
        type="button"
        class=""
        mat-button
        color="accent"
        tabindex="0"
        (click)="dialogRef.close(false)"
        (keyup)="($event.key === 'Enter') && dialogRef.close(false)"
      >
        <span class="bold">
          {{ 'TRANS__EDIT_OBJECT_DIALOG__CANCEL' | translate }}
        </span>
      </button>
    </div>
  }
</div>
